export function resetujHypotekarnuKalkulacku(settery) {
  settery.setUrok(3.50);
  settery.setSuma(100000);
  settery.setRoky(30);
  settery.setHodnotazabezpecenia(150000);
  settery.setFixacia(3);

  settery.setPocetziadatelov(1);
  settery.setPocetdeti(0);
  settery.setPocetdeti2(0);
  settery.setPocetdeti3(0);
  settery.setPocetdeti4(0);

  settery.setSpolocnadomacnost1(false);
  settery.setSpolocnadomacnost2(false);

  settery.setPrijem1(1500);
  settery.setVek1(30);
  settery.setPrijem2(0);
  settery.setVek2(0);
  settery.setPrijem3(0);
  settery.setVek3(0);
  settery.setPrijem4(0);
  settery.setVek4(0);

  settery.setAktivnyZiadatelTab(1);
  settery.setAktivnyZavazkyTab(1);

  settery.setHypoobjem(0);
  settery.setHyposplatnost(0);
  settery.setHyposadzba(0);
  settery.setHyposplatka(0);
  settery.setHypofixacia(0);
  settery.setOstatneobjem(0);
  settery.setOstatnesplatka(0);

  settery.setHypoobjem2(0);
  settery.setHyposplatnost2(0);
  settery.setHyposadzba2(0);
  settery.setHyposplatka2(0);
  settery.setHypofixacia2(0);
  settery.setOstatneobjem2(0);
  settery.setOstatnesplatka2(0);

  settery.setHypoobjem3(0);
  settery.setHyposplatnost3(0);
  settery.setHyposadzba3(0);
  settery.setHyposplatka3(0);
  settery.setHypofixacia3(0);
  settery.setOstatneobjem3(0);
  settery.setOstatnesplatka3(0);

  settery.setHypoobjem4(0);
  settery.setHyposplatnost4(0);
  settery.setHyposadzba4(0);
  settery.setHyposplatka4(0);
  settery.setHypofixacia4(0);
  settery.setOstatneobjem4(0);
  settery.setOstatnesplatka4(0);

  settery.setTypHypoteky('nadobudnutie');
  settery.setLtvMoznosti(null);

  settery.setPpOpen(false);
  settery.setPpJednoraz(0);
  settery.setPpMesacne(0);
  settery.setPpRocne(0);
  settery.setPpStart(0);
  settery.setPpOpakovania(0);
  settery.setPpRezim('skratenie');

  settery.setInvOpen(false);
  settery.setInvJednoraz(0);
  settery.setInvMesacne(0);
  settery.setInvZhodnotenie(6.0);
  settery.setInvHorizont(30);
  settery.setSkalRezim(null);
  settery.setInvProfil('vyvazeny');
  settery.setInvVystupPS(false);

  settery.setZmJednotlivec(284.14);
  settery.setZmDruhyDospely(198.23);
  settery.setZmDieta(129.75);

  settery.setPoznamka('');

  settery.setNazovSuboruPdf('Ponuka_hypoteka');
  settery.setMenoKlientaPdf('');
  settery.setPdfModalOtvoreny(false);
  settery.setPdfSekcie({
    zahrnutPredcasneSplatenie: false,
    zahrnutInvestovanie: false,
    zahrnutGraf: true,
    zahrnutSplatkovyKalendar: false,
    zahrnutPorovnavac: true,
    zahrnutPoznamku: false,
  });

  settery.setPorovnavacDataPrePdf({
    banky: [],
    zobrazeneBanky: [],
    zoznamBank: [],
    vybraneBanky: {},
    vsetkyBanky: true,
    maUcet: true,
    maPoistenieUveru: true,
    maPoistenieNehnutelnosti: true,
    maEkoCertifikat: true,
    fixacia: null,
    suma: 0,
    roky: 0,
    ltvPercenta: null,
    jeLoading: false,
    chyba: null,
  });
}